import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "app/components/Input";
import EmailIcon from "app/components/Icons/EmailIcon";
import PasswordIcon from "app/components/Icons/PasswordIcon";
import { Link } from "react-router-dom";
import { selectLoginForm } from "../../redux/selector";
import { actions } from "../../redux/slice";


export default function LoginForm() {
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const loginForm = useSelector(selectLoginForm);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(actions.setLoginFormValues({ name: e.target.name, value: e.target.value }));
  };

  return (
    <>
      <Input
        id="email"
        label="Email"
        type="email"
        name="email"
        placeholder="Enter email address"
        icon={<EmailIcon />}
        inputRef={emailRef}
        defaultValue={loginForm.email.value}
        error={loginForm.email.error}
        disabled={loginForm.isLoading}
        onChange={handleChange}
      />
      <div>
        <Input
          id="password"
          label="Password"
          type="password"
          name="password"
          placeholder="Password"
          icon={<PasswordIcon />}
          inputRef={passwordRef}
          defaultValue={loginForm.password.value}
          error={loginForm.password.error}
          disabled={loginForm.isLoading}
          onChange={handleChange}
        />
        <div className="flex justify-end mt-[6px]">
          <Link to="/auth/forgot-password" className="text-sm text-primary">
            Forgot password?
          </Link>
        </div>
      </div>
    </>
  );
}
